<template>
  <div v-if="loading" class="loader">
    <img alt="loading" src="@/assets/loading.gif" />
  </div>
</template>
<script>
export default {
  props: {
    loading: { type: Boolean, default: false }
  }
};
</script>
